import axios from "../../../axios";

export const getQueues = async (queue_name) => {
    try {
        let { data } = await axios.get(`${window._env.REACT_APP_EMCONSOLE_API_URL}/v1/queue?queue_name=${queue_name}`);
        return data;
    } catch (e) {
        console.log("error while getting workers", e)
    }
};
